import classnames from 'classnames';
import {
  CKContainerProps,
  CKLayoutGrid,
  excludeChildrenByDisplayName,
  includeChildrenByDisplayName,
} from 'clearkit';
import { FC } from 'react';
import { Link } from 'react-router-dom';

type ProspectorSidebarProps = CKContainerProps;

type BreadcrumbsProps = CKContainerProps;

type ProspectorSidebarComposition = {
  Breadcrumbs: FC<BreadcrumbsProps>;
  Footer: FC<CKContainerProps>;
};

const breadcrumbsDisplayName = 'ProspectorSidebar.Breadcrumbs';
const footerDisplayName = 'ProspectorSidebar.Footer';

export const ProspectorSidebar: FC<ProspectorSidebarProps> &
  ProspectorSidebarComposition = ({ children, className, ...rest }) => {
  return (
    <CKLayoutGrid
      {...rest}
      as="aside"
      className={classnames(className, 'w-[22rem] border-r border-gray-200')}
      gap="0"
      gridTemplateRows="auto 1fr auto"
    >
      <header className="p-6 py-8 space-y-2">
        {includeChildrenByDisplayName({
          children,
          componentDisplayName: breadcrumbsDisplayName,
        })}
        <h1 className="font-semibold text-[1.5rem]">Prospector</h1>
      </header>
      <div className="ck-scrollbar ck-scrollbar--vertical">
        {excludeChildrenByDisplayName({
          children,
          componentDisplayName: [breadcrumbsDisplayName, footerDisplayName],
        })}
      </div>
      {includeChildrenByDisplayName({
        children,
        componentDisplayName: footerDisplayName,
      })}
    </CKLayoutGrid>
  );
};

ProspectorSidebar.Breadcrumbs = ({ children, className, ...rest }) => (
  <div className={classnames(className, 'text-sm  text-gray-600')} {...rest}>
    <Link className="font-normal !text-gray-600" to="/prospector">
      Prospector
    </Link>{' '}
    / <span className="font-medium text-gray-900">{children}</span>
  </div>
);
ProspectorSidebar.Breadcrumbs.displayName = breadcrumbsDisplayName;

ProspectorSidebar.Footer = ({ children, className, ...rest }) => (
  <footer className={classnames(className, 'p-6')} {...rest}>
    {children}
  </footer>
);
ProspectorSidebar.Footer.displayName = footerDisplayName;
